import { SettingModel } from 'Models'
import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'

export const settingApi = {
	getAllSetting: async () => {
		const res = await axiosDS().get<SettingModel[]>(urls.modules.setting.index)
		return res.data
	},

	getSetting: async (key: string) => {
		const res = await axiosDS().get<SettingModel>(`${urls.modules.setting.index}/${key}`)
		return res.data
	},

	updateSetting: async (data: { [key: string]: any }, key: string) => {
		// отправляем только data: {data : {нужные данные для бэка} а не полностью Settings: {data, key}
		const res = await axiosDS().patch<SettingModel>(`${urls.modules.setting.index}/${key}`, {
			data: { data },
		})
		return res.data
	},

	getEventsSetting: async () => {
		const res = await axiosDS().get<SettingModel[]>(urls.coliseum.events_setting)
		return res.data
	},
}
